import { jsxs, jsx } from 'react/jsx-runtime';
import { Button } from '../page-layout/Button.js';
import { Header, HeaderTitle, HeaderDescription } from '../page-layout/Header.js';
import '../ui/alert.js';
import '@radix-ui/react-avatar';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import '../ui/button.js';
import '@radix-ui/react-progress';
import '@clerk/clerk-react';
import { Search, Plus } from 'lucide-react';
import 'react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import '../form/RichTextEditor.js';
import '@radix-ui/react-switch';
import './CrudDetailView.js';
import './CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';
import '../ui/badge.js';
import 'react-day-picker';
import '../ui/chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import { Input } from '../ui/input.js';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '../ui/radio-group.js';
import '@radix-ui/react-select';
import '../ui/time-input.js';
import '@radix-ui/react-separator';
import '../ui/sidebar.js';
import 'react-toastify';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';

/**
 * Header component for CRUD list views
 * Displays entity name, description, an optional middle search box, and action
 * buttons (Add, Create).
 */
function CrudListHeader({ config, baseUrl, navigate, onAddClick, customActions = [], headerRight, search, }) {
    const actionConfig = config.listView.actions || {};
    // Whether anything renders in the right-hand action area. When nothing does,
    // the search box takes the action area's place on the far right instead of
    // sitting in the middle of the header.
    const hasActions = Boolean(headerRight) ||
        customActions.length > 0 ||
        Boolean(actionConfig.add?.enabled) ||
        Boolean(actionConfig.create?.enabled);
    const handleCreateClick = () => {
        const createConfig = actionConfig.create;
        if (!createConfig)
            return;
        if (createConfig.onClick) {
            createConfig.onClick();
        }
        else if (createConfig.url) {
            navigate(createConfig.url);
        }
        else {
            const url = baseUrl ? `${baseUrl}/new` : `${config.endpoints.create}/new`;
            navigate(url);
        }
    };
    return (jsxs("div", { className: "flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4", children: [jsxs(Header, { children: [jsx(HeaderTitle, { children: config.entityNamePlural }), jsxs(HeaderDescription, { children: ["Manage your ", config.entityNamePlural.toLowerCase()] })] }), search && (jsxs("div", { className: cn('relative w-full md:w-[300px] md:shrink-0 md:self-end', !hasActions && 'md:ml-auto'), children: [jsx(Search, { className: "absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" }), jsx(Input, { value: search.value, onChange: e => search.onChange(e.target.value), placeholder: search.placeholder ?? `Search ${config.entityNamePlural.toLowerCase()}...`, className: "pl-9" })] })), hasActions && (jsxs("div", { className: "flex flex-col sm:flex-row sm:items-center gap-2 w-full md:w-auto md:self-end", children: [headerRight, customActions.map(action => (jsx(Button, { variant: action.variant || 'outline', onClick: action.onClick, icon: action.icon, loading: action.loading, children: action.label }, action.key))), actionConfig.add?.enabled && (jsx(Button, { onClick: onAddClick, variant: "default", icon: Plus, children: actionConfig.add.label || `Add ${config.entityName}` })), actionConfig.create?.enabled && (jsx(Button, { onClick: handleCreateClick, icon: Plus, children: actionConfig.create.label || `Create ${config.entityName}` }))] }))] }));
}

export { CrudListHeader };
//# sourceMappingURL=CrudListHeader.js.map
